import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useObserver } from "mobx-react-lite";
import { useStores } from "../../../store";
import { DownloadResume } from "../resume_output";

const Resume11 = () => {
  const { ResumeStore } = useStores();
  const resumeRef = useRef(null);

  const handleDownload = useReactToPrint({
    content: () => resumeRef.current,
  });

  return useObserver(() => (
    <>
      <DownloadResume onClick={handleDownload} />
      <div
        className="w-full mx-auto my-10 p-5 border border-black shadow-md bg-white"
        ref={resumeRef}
      >
        <div className="text-center mb-2">
          <h1 className="text-2xl font-bold">
            {ResumeStore?.resumeBuilder.personalDetails.firstName}{" "}
            {ResumeStore?.resumeBuilder.personalDetails.lastName}
          </h1>
          <p className="mt-1 text-base">
            {ResumeStore?.resumeBuilder.personalDetails.address} •{" "}
            {ResumeStore?.resumeBuilder.personalDetails.city},{" "}
            {ResumeStore?.resumeBuilder.personalDetails.state}{" "}
            {ResumeStore?.resumeBuilder.personalDetails.postalCode} •{" "}
            {ResumeStore?.resumeBuilder.personalDetails.phone} •{" "}
            {ResumeStore?.resumeBuilder.personalDetails.email}
          </p>
        </div>
        <hr className="my-3 border-black" />
        <div className="mb-5">
          <h2 className="text-xl font-bold mb-1 border-b border-black">
            OBJECTIVE
          </h2>
          <p className="text-base">
            {ResumeStore?.resumeBuilder.profileSummary}
          </p>
        </div>
        <div className="mb-5">
          <h2 className="text-xl font-bold mb-1 border-b border-black">
            EDUCATION
          </h2>
          {ResumeStore?.resumeBuilder.education.map((edu, index) => (
            <div key={index} className="mb-4">
              <p className="font-bold">
                {edu.school}{" "}
                <span className="float-right">
                  {edu.city}, {edu.state} • {edu.endDate}
                </span>
              </p>
              <p className="ml-2">{edu.degree}</p>
              <ul className="list-disc ml-6">
                <li className="mb-1">{edu.description}</li>
              </ul>
            </div>
          ))}
        </div>
        <div className="mb-5">
          <h2 className="text-xl font-bold mb-1 border-b border-black">
            WORK EXPERIENCE
          </h2>
          {ResumeStore?.resumeBuilder.employementHistory.map((job, index) => (
            <div key={index} className="mb-4">
              <p className="font-bold">
                {job.company}{" "}
                <span className="float-right">
                  {job.city}, {job.state} • {job.startDate} - {job.endDate}
                </span>
              </p>
              <p className="ml-2">{job.jobTitle}</p>
              <ul className="list-disc ml-6">
                {job.description?.split("\n").map((desc, i) => (
                  <li key={i} className="mb-1">
                    {desc}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mb-5">
          <h2 className="text-xl font-bold mb-1 border-b border-black">
            VOLUNTEER EXPERIENCE
          </h2>
          {ResumeStore?.resumeBuilder.extraCurricularActivities?.map(
            (activity, index) => (
              <div key={index} className="mb-4">
                <p className="font-bold">
                  {activity.functionTitle}{" "}
                  <span className="float-right">
                    {activity.city}, {activity.state} • {activity.startDate} -{" "}
                    {activity.endDate}
                  </span>
                </p>
                <p className="ml-2">{activity.description}</p>
              </div>
            )
          )}
        </div>
      </div>
    </>
  ));
};

export default Resume11;
